import moment from 'moment'
import z from 'zod'
import { validateEquipmentId } from '../../../../Service/components/NewDrawers/consts/searchDrawer.consts'
import { RequestType } from '../../../../SingleRequestPage/types/Request.type'

export const changeInstallationSchema = z.object({
  equipmentId: z.string().refine((val) => !val || validateEquipmentId(val), {
    message: 'Неверный формат id оборудования',
  }),
  receiverSerialNumber: z.string().refine((val) => val.length === 23),
  receiverModelId: z.string().refine((val) => !!val),
  installationDate: z.string().refine(
    (value) => {
      // Преобразуем значение в Moment, если это строка
      const date =
        typeof value === 'string'
          ? moment(value, 'YYYY-MM-DDTHH:mm:ssZ')
          : moment(value) // если уже Moment объект

      return date.isSameOrBefore(moment(), 'day')
    },
    {
      message: 'Дата не должна быть в будущем',
    },
  ),
  // если есть встроенная смарт-карта - ошибка
  smartCardId: z
    .string()
    .nullable()
    .refine((val) => !val, {
      message: 'Ошибка встроенной карты',
    }),
  hasCas: z.boolean(),
})

export type InstallationDataNewForm = z.infer<typeof changeInstallationSchema>

export const getDefaultValues = (
  request?: RequestType,
): InstallationDataNewForm => {
  return {
    installationDate: request?.installationDate
      ? moment(request.installationDate).format('YYYY-MM-DDTHH:mm:ssZ')
      : moment().format('YYYY-MM-DDTHH:mm:ssZ'),
    equipmentId: request?.equipmentId ?? '',
    receiverSerialNumber: request?.receiverSerialNumber ?? '',
    receiverModelId: request?.receiverProduct ?? '',
    smartCardId: null,
    hasCas: request?.hasCas ?? false,
  }
}

export const getReportPeriod = (request: RequestType) => {
  if (!request.reportPeriodFrom) {
    return {
      from: null,
      to: null,
    }
  }
  const installationMoment = moment(request.installationDate)

  let reportPeriodFrom = installationMoment
    .clone()
    .date(request?.reportPeriodFrom as number)
    .startOf('day')
  let reportPeriodTo = installationMoment
    .clone()
    .date(request?.reportPeriodTo as number)
    .endOf('day')

  const isValid = reportPeriodFrom.isValid() && reportPeriodTo.isValid()

  return {
    from: isValid ? reportPeriodFrom : null,
    to: isValid ? reportPeriodTo : null,
  }
}
